import React from 'react';
import HedinIcon from '@hedinbil/hedin-ui/dist/icons/components/HedinIcon';
import { Collapse } from '@hedinbil/hedin-ui/dist/base/modules/collapse/Collapse';
import SalesPersonCard from './SalesPersonCard';

const formatWeekdays = (name) => {
  switch (name) {
    case 'weekdays':
      return 'Vardagar';
    case 'saturday':
      return 'Lördag';
    case 'sunday':
      return 'Söndag';
    default:
      return name;
  }
};

const ContactArea = (props) => {
  const { brands, email, phone, name, openDay, openHours, users, content } = props;
  const phoneHref = 'tel:' + phone;
  const mailHref = 'mailto:' + email;

  return (
    <div className="row contact-area px-1 bg-white">
      <div className="col-lg-12 py-2">
        <h2>{name}</h2>
        <div className="contact-area__container d-flex flex-column">
          <div className="row">
            <div className="col-lg-4 col-md-6 col-sm-12 contact-area__content pb-2">
              <p className="color-black fw-700 text-uppercase">Kontakt</p>
              <div className="contact-area__content-link">
                {phone !== null && (
                  <a href={phoneHref} className="contact-link d-flex">
                    <HedinIcon iconName="Phone" />
                    <span>{phone}</span>
                  </a>
                )}
              </div>
              <div className="contact-area__content-link">
                {email && (
                  <a href={mailHref} className="contact-link d-flex text-lowercase">
                    <HedinIcon iconName="Mail" />
                    <span>{email}</span>
                  </a>
                )}
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 contact-area__content pb-2">
              <p className="color-black fw-700 text-uppercase">Åpningstider</p>
              <div className="d-flex">
                <div className="contact-area__open-days d-flex">
                  {(openDay || []).map((item, index) => (
                    <span key={index}>{formatWeekdays(item)}</span>
                  ))}
                </div>
                <div className="contact-area__open-houers d-flex">
                  {(openHours || []).map((item, index) => (
                    <span key={index}>
                      {item?.open && item?.close && (
                        <>
                          {item?.open.trim()} - {item?.close.trim()}
                        </>
                      )}
                      {/[a-zA-Z]/g.test(item?.close)
                        ? item.close
                        : /[a-zA-Z]/g.test(item?.open)
                          ? item.open
                          : null}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12 contact-area__content pb-2">
              <p className="color-black fw-700 text-uppercase">{content?.title}</p>
              <p className="contact-area__content-text">{content?.message}</p>
              {content?.url && content?.buttonText !== '' && (
                <a href={content?.url} className="button button__primary">
                  {content?.buttonText}
                </a>
              )}
            </div>
          </div>
          {brands && brands.length > 0 ? (
            <div className="contact-area__container-logos d-flex">
              {(brands || []).map((item, index) => (
                <img
                  key={index}
                  alt={item?.brandCode + ' logo'}
                  src={`/-/media/Project/Hedin/Shops/BavariaNoSite/Brands/${item?.brandCode}.jpg`}
                  onError={(e) => (e.target.style.display = 'none')}
                />
              ))}
            </div>
          ) : null}
        </div>
        <div className="contact-area__staff">
          {users.length > 0 && (
            <Collapse buttonText="ansatte">
              <div className="row contact-area__staff-container">
                {(users || []).map((item, index) => (
                  <div key={index} className="col-md-6 col-lg-4 ">
                    <SalesPersonCard
                      adId={item?.adId}
                      email={item?.email}
                      firstName={item?.firstName}
                      lastName={item?.lastName}
                      locationId={item?.locationId}
                      phone={item?.phone}
                      title={item?.title}
                    />
                  </div>
                ))}
              </div>
            </Collapse>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactArea;
